import { render, staticRenderFns } from "./VisitorHistory.vue?vue&type=template&id=5c3904e2&scoped=true"
import script from "./VisitorHistory.vue?vue&type=script&lang=js"
export * from "./VisitorHistory.vue?vue&type=script&lang=js"
import style0 from "./VisitorHistory.vue?vue&type=style&index=0&id=5c3904e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3904e2",
  null
  
)

export default component.exports